<template>
  <div class="online-pay">
    <main class="content">
      <el-card>
        <el-form :inline="true" :model="searchForm" size="mini">
          <el-form-item label="订单编号">
            <el-input v-model="searchForm.orderNo" placeholder="订单编号" size="mini" clearable style="width: 150px"></el-input>
          </el-form-item>
          <el-form-item label="下单公司">
            <el-input v-model="searchForm.companyName" placeholder="下单公司" size="mini" clearable style="width: 150px"></el-input>
          </el-form-item>
          <el-form-item label="支付银行">
            <el-input v-model="searchForm.issuerBankName" placeholder="支付银行" size="mini" clearable style="width: 150px"></el-input>
          </el-form-item>
          <el-form-item label="支付状态">
            <el-select v-model="searchForm.payStatus" placeholder="支付状态" size="mini" clearable style="width: 120px">
              <el-option label="待支付" :value="0"></el-option>
              <el-option label="支付成功" :value="1"></el-option>
              <el-option label="支付失败" :value="2"></el-option>
              <el-option label="订单超时" :value="3"></el-option>
              <el-option label="支付中" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单状态">
            <el-select v-model="searchForm.orderStatus" placeholder="订单状态" size="mini" clearable style="width: 120px">
              <el-option label="内部审批中" :value="0"></el-option>
              <el-option label="待审批" :value="1"></el-option>
              <el-option label="已下单" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下单时间">
            <el-date-picker size="mini" v-model="searchForm.orderDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
          </el-form-item>
          <el-form-item label="支付时间">
            <el-date-picker size="mini" v-model="searchForm.payDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="doSearch" size="mini">查询</el-button>
          </el-form-item>
        </el-form>
        <div ref="tablePosition"></div>
        <el-table stripe :data="tableData" v-loading="loading" style="width: 100%" size="mini" :height="tableConfig.height">
          <el-table-column prop="orderNo" label="订单编号" min-width="160" />
          <el-table-column prop="companyName" label="下单公司" min-width="140" />
          <el-table-column prop="createTime" label="下单时间" width="160" />
          <el-table-column prop="total" label="订单金额" width="100">
            <template slot-scope="scope">
              {{ scope.row.total ? scope.row.total.toFixed(2) : '0.00' }}
            </template>
          </el-table-column>
          <el-table-column prop="issuerBankName" label="支付银行" min-width="120" />
          <el-table-column prop="payCreateTime" label="发起支付时间" width="160" />
          <el-table-column prop="payModifiedTime" label="结束支付时间" width="160" />
          <el-table-column prop="payStatusShow" label="支付状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="payStatusTag(scope.row.payStatus)" size="mini">{{ scope.row.payStatusShow }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="orderStatusShow" label="订单状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="orderStatusTag(scope.row.orderStatus)" size="mini">{{ scope.row.orderStatusShow }}</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center; padding-top: 20px" v-if="total > 0">
          <el-pagination
            background
            layout="sizes,prev, pager, next"
            :total="total"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            @size-change="handleSizeChange"
            @current-change="onPageChange"
            :current-page="currentPage"
            @prev-click="onPageChange"
            @next-click="onPageChange">
          </el-pagination>
        </div>
      </el-card>
    </main>
  </div>
</template>

<script>
const HEIGHT_OFFSET = 118;

export default {
  data() {
    return {
      tableConfig: { height: 0 },
      searchForm: {
        orderNo: "",
        companyName: "",
        issuerBankName: "",
        payStatus: 1,
        orderStatus: "",
        orderDate: "",
        payDate: "",
      },
      loading: false,
      total: 0,
      pageSize: 10,
      currentPage: 1,
      tableData: [],
    }
  },
  methods: {
    doSearch() {
      this.currentPage = 1;
      this.onSearch();
    },
    onSearch() {
      let cond = {};
      if (this.searchForm.orderNo != "") cond["orderNo"] = this.searchForm.orderNo;
      if (this.searchForm.companyName != "") cond["companyName"] = this.searchForm.companyName;
      if (this.searchForm.issuerBankName != "") cond["issuerBankName"] = this.searchForm.issuerBankName;
      if (this.searchForm.payStatus !== "" && this.searchForm.payStatus !== null) cond["payStatus"] = this.searchForm.payStatus;
      if (this.searchForm.orderStatus !== "" && this.searchForm.orderStatus !== null) cond["orderStatus"] = this.searchForm.orderStatus;
      if (this.searchForm.orderDate != "" && this.searchForm.orderDate != null) {
        cond["orderDateStart"] = this.searchForm.orderDate[0];
        cond["orderDateEnd"] = this.searchForm.orderDate[1];
      }
      if (this.searchForm.payDate != "" && this.searchForm.payDate != null) {
        cond["payDateStart"] = this.searchForm.payDate[0];
        cond["payDateEnd"] = this.searchForm.payDate[1];
      }

      this.loading = true;
      let _this = this;
      this.$axios.post("/admin/onlinePay/search", {
        cond: cond,
        page: this.currentPage - 1,
        size: this.pageSize
      }).then(function(response) {
        let resp = response.data;
        if (resp.header.status == 0) {
          _this.loading = false;
          _this.tableData = resp.data.content;
          _this.total = resp.data.totalElements;
        }
      }).catch(function() {});
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.onSearch();
    },
    onPageChange(currentPage) {
      this.currentPage = currentPage;
      this.onSearch();
    },
    payStatusTag(status) {
      const map = { 0: 'warning', 1: 'success', 2: 'danger', 3: 'info', 4: 'primary' };
      return map[status] || 'info';
    },
    orderStatusTag(status) {
      const map = { 0: 'warning', 1: 'primary', 2: 'success' };
      return map[status] || 'info';
    },
    setTableHeight() {
      const tablePosition = this.$refs['tablePosition'];
      if (!tablePosition) {
        this.$nextTick(() => { this.setTableHeight(); });
        return;
      }
      try {
        const { top } = tablePosition.getBoundingClientRect();
        this.tableConfig.height = Math.max(window.innerHeight - top - HEIGHT_OFFSET, 200);
      } catch (e) {
        this.tableConfig.height = 400;
      }
    },
  },
  mounted() {
    setTimeout(() => { this.setTableHeight(); }, 500);
  },
  created() {
    this.onSearch();
    window.addEventListener("resize", this.setTableHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.setTableHeight);
  },
}
</script>

<style>
</style>
